








































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import version from "@/version";
@Component({})
export default class NumCurrencySubsidiary extends Vue {
    @Prop({ type: Object })
    subjectVal?: Subject.Subject;

    @Prop({ type: Array })
    tableData?: Subject.Subject[];

    @Prop({ type: Array })
    period!: string[];

    @Prop({ type: String })
    yearMonth?: string;

    // 下载
    downLoad() {
        let url = "";
        if (this.subjectVal) {
            if (this.subjectVal.currSymbol === null && this.subjectVal.measuringUnit != null) url = "export/subsidiaryledger/num";
            else if (this.subjectVal.currSymbol != null && this.subjectVal.measuringUnit != null) url = "export/subsidiaryledger/numcurr";
            else if (this.subjectVal.currSymbol != null && this.subjectVal.measuringUnit === null) url = "export/subsidiaryledger/curr";
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}${url}?accountBookId=${this.$store.state.accountBook.id}&subjectId=${this.subjectVal.id}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&version=${version}&token=${this.$store.state.account.token}`);
        }
    }
    // 打印
    print() {
        let url = "";
        if (this.subjectVal) {
            if (this.subjectVal.currSymbol === null && this.subjectVal.measuringUnit != null) url = "export/pdf/subsidiaryledger/num";
            else if (this.subjectVal.currSymbol != null && this.subjectVal.measuringUnit != null) url = "export/pdf/subsidiaryledger/numcurr";
            else if (this.subjectVal.currSymbol != null && this.subjectVal.measuringUnit === null) url = "export/pdf/subsidiaryledger/curr";
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}${url}?accountBookId=${this.$store.state.accountBook.id}&subjectId=${this.subjectVal.id}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&version=${version}&token=${this.$store.state.account.token}`);
        }
    }

    isVoucher = false;
    openDialogVoucher(data: Subsidiary) {
		if (data.voucherId != -1) {
			this.isVoucher = true;
			this.$nextTick(function () {
				let comVoucher: any = this.$refs.voucher;
				comVoucher.isDialog = true;
				comVoucher.shouldGetInit = false;
				comVoucher.getSubjectList(
					data.date.replace(/-/, "").substring(0, 6),
					() => {
						Vue.axios
							.post(`voucher/` + data.voucherId + `/find`, {
								id: 123,
							})
							.then((res) => {
								comVoucher.packVoucher(res.data);
								comVoucher.isEdit = true;
								comVoucher.showSaveAndAdd = false;
								comVoucher.showAdd = false;
							});
					}
				);
			});
		}
	}
}
